module.exports = __webpack_public_path__ + "img/Dudey.8b842344.webp";